import { useSuspenseQuery } from '@tanstack/react-query';
import { getListForCreation } from '~/api';
import { GetListForCreationData } from '~/types';
import { MINUTE } from '~/constants';
import useToast from '~/store/useToast';
import characterKey from './characterKey';

const useGetListForCreationQuery = () => {
  const { showToast } = useToast();
  return useSuspenseQuery({
    queryKey: characterKey.getListForCreation(),
    queryFn: () => getListForCreation(),
    select: ({ data, status }) => {
      return data as GetListForCreationData[];
    },
    staleTime: 2 * MINUTE,
  });
};

export default useGetListForCreationQuery;
